import { Button } from "#ui/button";
import {
  Dialog,
  DialogCloseIconButton,
  DialogContent,
  DialogHeader,
  DialogMain,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "#ui/dialog";
import { Icon } from "#ui/icon";
import { H2, P } from "#ui/typography";

type SuccessDialogParams = {
  text: string;
  title: string;
  open?: boolean;
  defaultOpen?: boolean;
  proceed: () => void;
};

export function SuccessDialog({
  text,
  title,
  open,
  defaultOpen,
  proceed,
}: SuccessDialogParams) {
  return (
    <Dialog open={open} defaultOpen={defaultOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          aria-describedby={undefined}
          variant="center-scroll-inner"
          className="max-w-450px self-start"
        >
          <DialogHeader className="sr-only">
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <DialogMain>
            <div className="mt-40px grid place-items-center gap-15px text-center">
              <Icon
                name="baird-checkmark-circle"
                size="baird-lg"
                palette="success"
                className="mb-5px"
              />
              <H2 size="h5" className="leading-none" aria-hidden>
                {title}
              </H2>
              <P size="sm" palette="neutral-subtle">
                {text}
              </P>
              <Button className="mx-10px mb-10px w-full" onClick={proceed}>
                Continue
              </Button>
            </div>
            <DialogCloseIconButton onClick={proceed} />
          </DialogMain>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
